import './broker-form.scss';

import { ActivateBrokerBrokerage } from './active-broker-brokerage';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DeactivateBrokerBrokerage } from './inactive-warning';
import { InactiveTag } from '../../../../presentation';
import { Typography } from '@mui/material';

type Props = {
  value?: number;
  uuid?: string;
  onArrowClick: () => void;
  onClickDeactivate?: () => void;
  onClickReactivate?: () => void;
  name: string | null;
  isBroker?: boolean;
  active?: boolean;
  showStatus?: boolean;
};

export const BrokerBrokerageHeader = ({
  value,
  uuid,
  onArrowClick,
  name,
  isBroker,
  active,
  showStatus,
  onClickReactivate,
  onClickDeactivate,
}: Props) => {
  return (
    <span
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ArrowBackIcon
          sx={{
            height: '24px',
            width: '24px',
            paddingTop: '30px',
            paddingLeft: '20px',
          }}
          onClick={onArrowClick}
          data-testid="navigate-back-button"
        />
        <Typography
          className="form-title"
          variant="body1"
          sx={{
            fontSize: '34px',
            fontWeight: 400,
            letterSpacing: 0,
            marginLeft: '32px',
            paddingTop: '30px',
            cursor: 'default',
          }}
        >
          {value === 0 && !uuid
            ? `Add New ${isBroker ? 'Broker' : 'Brokerage'}`
            : value !== 0 && !uuid
            ? 'Add New Note'
            : ''}
          {uuid && (
            <>
              {active ? (
                <>
                  <span className="broker-title">View or Edit</span>
                  <span className="broker-name">{name}</span>
                </>
              ) : (
                <span className="broker-name">
                  {name} <InactiveTag />
                </span>
              )}{' '}
            </>
          )}
        </Typography>
      </div>
      {showStatus &&
        (active ? (
          <DeactivateBrokerBrokerage
            isBroker={isBroker}
            onClickDeactivate={onClickDeactivate}
          />
        ) : (
          <ActivateBrokerBrokerage
            isBroker={isBroker}
            onClickReactivate={onClickReactivate}
          />
        ))}
    </span>
  );
};
